import React from "react";
import Loader from "../Loader";
import EmptyState from "./EmptyState";
import ErrorState from "./ErrorState";

/**
 * The non-table half of the same loading/empty/error contract DataTable
 * enforces — for detail panes and card grids, which have no <thead> to hang a
 * skeleton off.
 *
 * Same rule: red + Retry means the request failed, grey means it succeeded and
 * returned nothing. Never let a caught error fall through to the empty state.
 */
export default function AsyncSection({
  state = "idle",
  error = null,
  onRetry,
  isEmpty = false,
  loadingMessage = "Loading...",
  emptyTitle = "Nothing here",
  emptyMessage,
  emptyIcon,
  isFiltered = false,
  onClearFilters,
  compact = false,
  children,
}) {
  if (state === "loading") return <Loader message={loadingMessage} />;

  if (state === "error") {
    return <ErrorState error={error} onRetry={onRetry} compact={compact} />;
  }

  if (state === "success" && isEmpty) {
    return (
      <EmptyState
        icon={emptyIcon}
        title={emptyTitle}
        message={emptyMessage}
        isFiltered={isFiltered}
        onClearFilters={onClearFilters}
        compact={compact}
      />
    );
  }

  if (state === "idle") return null;

  return children;
}
